/**
 * Hash type exports
 * Re-exports types from HashType.ts for JSDoc usage in .js files
 *
 * @typedef {import('./HashType.js').HashType} HashType
 */

export const SIZE = 32;
